import { createContext } from 'react'
import { PropertyFilters } from '../lib/supabase'
import type { Property, StProperty } from '../types'

export interface PropertiesContextType {
  // State
  filters: PropertyFilters
  properties: Property[]
  stProperties: StProperty[]
  selectedStaysProperty: StProperty | null
  isStPropertiesLoading: boolean
  isLoading: boolean
  error: Error | null
  count: number
  isStaysPropertiesOpen: boolean
  isSyncLoading: boolean

  // Actions
  setFilters: (filters: PropertyFilters) => void
  handlePropertyClick: (id: string) => void
  handleNewProperty: (staysSynced?: boolean) => void
  refreshProperties: () => void
  setSelectedStaysProperty: React.Dispatch<
    React.SetStateAction<StProperty | null>
  >
  onStaysPropertiesOpen: () => void
  onStaysPropertiesClose: () => void
  syncStaysProperties: () => Promise<void>

  // CRUD Operations
  softDelete: (id: string) => void
  restore: (id: string) => void
  isDeleting: boolean
  isRestoring: boolean
}

export const PropertiesContext = createContext<
  PropertiesContextType | undefined
>(undefined)
